<script setup lang="ts">
import { getTransitionProps } from 'ant-design-vue/lib/_util/transition';
</script>

<template>
  <Transition v-bind="getTransitionProps('ant-fade')">
    <slot />
  </Transition>
</template>

<style lang="scss" scoped>
@use './FadeMotion.scss';
</style>
